module.exports = __webpack_public_path__ + "static/testimonial-ian-tetley-301ea3546cd02724367d1f774d9d4160.jpg";